import { useState } from "react";

export function EmployeeFilter({ setFilterDataIndex }) {
	const [selectedOption, setSelectedOption] = useState("All");

	const handleSelectChange = (event) => {
		setSelectedOption(event.target.value);

		switch (event.target.value) {
			case "All":
				setFilterDataIndex(0);
				break;
			case "EmployeeId":
				setFilterDataIndex(1);
				break;
			default:
				setFilterDataIndex(0);
				break;
		}
	};

	return (
		<select
			id=""
			className="filterSelect"
			value={selectedOption}
			onChange={handleSelectChange}
		>
			<option value="All">All</option>
			<option value="EmployeeId">Employee Id</option>
		</select>
	);
}